export default __webpack_public_path__ + "static/media/s-knowledge.3890bfb5.webp";